<template>
  <header id="site-header" class="site-header header-fullwidth" :class="isHome ? 'header-style-1' : 'header-style-2'">
    <div class="site-header--wrapper">
      <!-- Main Header start -->
      <div class="container">
        <div v-if="isDesktop" class="octf-main-header">
          <div class="octf-area-wrap">
            <div class="container-fluid octf-mainbar-container">
              <div class="octf-mainbar">
                <div class="octf-mainbar-row octf-row">
                  <!-- logo start -->
                  <div class="octf-col site-header--top-concept flex justify-between items-center">
                    <div class="h-header--slogan">Zarafetin Detaylarda Gizli Hali</div>
                    <q-no-ssr>
                      <div v-if="!isLogged" class="site-header--user-actions" v-cloak>
                        <span class="q-px-md">Hoşgeldin !</span>
                        <q-btn color="primary" no-caps href="/login-or-register">
                          <q-icon name="fa-solid fa-circle-plus" size="1rem" left />
                          Kayıt Ol
                        </q-btn>
                        <span class="q-px-md"> yada </span>
                        <q-btn style="background: #ffee53" no-caps href="/login-or-register">
                          <q-icon name="fa-solid fa-arrow-right-to-bracket" size="1rem" left />
                          Giriş Yap
                        </q-btn>
                      </div>
                    </q-no-ssr>
                    <div class="site-header--social-platforms">
                      <a
                        :key="key"
                        v-for="(social, key) in siteSocialInfo"
                        class="social"
                        :class="{ [`social-${key}`]: social }"
                        :style="{ backgroundImage: `url(/img/social-${key}.svg)` }"
                        :href="social.link"
                        target="_blank"
                        ><span style="display: none">{{ social.name }}</span>
                      </a>
                    </div>
                  </div>
                  <div class="site-header--middle-concept octf-col">
                    <div id="site-logo" class="site-logo">
                      <a :href="`${siteAddress}/`">
                        <img class="logo-static" src="/img/site-logo.png" :alt="head.title.siteTitle" />
                      </a>
                    </div>

                    <search-bar />

                    <div class="site-user-area">
                      <q-btn v-if="!isLogged" no-caps color="primary" class="q-mr-md" :href="`${siteAddress}/login-or-register`">
                        <q-icon name="fa-solid fa-user" size="1rem" left />
                        Hesabım
                      </q-btn>
                      <q-btn v-else no-caps color="primary" class="q-mr-md">
                        <q-icon name="fa-solid fa-user" size="1rem" left />
                        Hesabım
                        <q-menu transition-show="flip-right" transition-hide="flip-left">
                          <div class="row no-wrap q-pa-md">
                            <div class="column">
                              <div class="text-h6 flex items-center q-mb-md">
                                Hesabım
                                <q-btn round size=".6rem" color="grey-4" class="q-ml-sm" unelevated href="/user">
                                  <q-icon name="fa-solid fa-chevron-right" color="black" size=".6rem" />
                                </q-btn>
                              </div>
                              <q-list style="min-width: 100px">
                                <q-item clickable href="/user/orders">
                                  <q-item-section>
                                    <div class="flex items-center">
                                      <q-icon name="fa-solid fa-hand-holding-droplet" left />
                                      Siparişlerim
                                    </div>
                                  </q-item-section>
                                </q-item>
                                <q-item clickable href="/user/favourites">
                                  <q-item-section>
                                    <div class="flex items-center">
                                      <q-icon name="fa-regular fa-heart" left />
                                      Favorilerim
                                    </div>
                                  </q-item-section>
                                </q-item>
                                <q-separator />
                                <q-item clickable href="/user/contacts">
                                  <q-item-section>
                                    <div class="flex items-center">
                                      <q-icon name="fa-regular fa-address-book" left />
                                      Adreslerim
                                    </div>
                                  </q-item-section>
                                </q-item>
                              </q-list>
                            </div>

                            <q-separator vertical inset class="q-mx-lg" />

                            <div class="column justify-center items-center">
                              <q-avatar size="72px" class="bg-grey-3">
                                <svg viewBox="0 0 24 24" width="50px" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                  <g id="SVGRepo_iconCarrier">
                                    <circle cx="12" cy="6" r="4" stroke="#1C274C" stroke-width="1.5"></circle>
                                    <ellipse opacity="0.5" cx="12" cy="17" rx="7" ry="4" stroke="#1C274C" stroke-width="1.5"></ellipse>
                                  </g>
                                </svg>
                              </q-avatar>

                              <div class="text-subtitle1 q-mt-md q-mb-xs" v-if="me">{{ me.name }}</div>

                              <q-btn color="primary" label="Çıkış Yap" push size="sm" v-close-popup @click="logout" />
                            </div>
                          </div>
                        </q-menu>
                      </q-btn>
                      <q-btn no-caps color="secondary" :href="`${siteAddress}/basket`">
                        <q-icon name="fa-solid fa-basket-shopping" size="1rem" left />
                        Sepetim
                        <q-badge rounded color="primary" :label="userBasketCount" class="q-ml-sm" style="position: relative; top: 1px" />
                      </q-btn>
                    </div>
                  </div>
                  <!-- logo start -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--         Header mobile -->
        <div v-else class="header_mobile">
          <div class="container">
            <div class="header-mobile--wrapper clearfix">
              <!-- logo mobile start -->
              <div class="header-mobile--logo">
                <a href="/"><img src="/img/site-logo.png" :alt="head.title.siteTitle" /></a>
              </div>
              <!-- logo mobile end -->

              <div class="header-mobile--burger-menu">
                <q-btn dense color="primary" size="1rem" @click="toggleMenuDrawer" no-caps>
                  <q-icon name="menu" size="1.2rem" left />
                  Menü
                </q-btn>
              </div>
            </div>

            <div class="header-mobile--sub">
              <search-bar />
            </div>

            <div class="header-mobile--user">
              <div class="header-mobile--user_text">
                <p v-if="!isLogged">Hoşgeldiniz,</p>
              </div>
              <div v-if="isLogged">
                <q-no-ssr>
                  <q-btn color="secondary" size="1rem" unelevated class="header-mobile--basket_btn" dense href="/basket" no-caps>
                    <q-icon name="fa-solid fa-basket-shopping" size=".85rem" class="q-mr-sm" />
                    Sepetim
                    <q-badge rounded color="primary" :label="userBasketCount" class="q-ml-sm" style="position: relative; top: 1px" />
                  </q-btn>
                  <q-btn no-caps color="primary" size="1rem" unelevated flat class="header-mobile--profile_btn" dense>
                    Profilim
                    <q-icon name="fa-solid fa-user" size=".7rem" right />
                    <span class="header-mobile--profile_btn-down">
                      <q-icon name="fa-solid fa-caret-down" size=".9rem" right />
                    </span>
                    <q-menu transition-show="flip-right" transition-hide="flip-left">
                      <div class="row no-wrap q-pa-md">
                        <div class="column">
                          <div class="text-h6 flex items-center q-mb-md">
                            Hesabım
                            <q-btn round size=".6rem" color="grey-4" class="q-ml-sm" unelevated href="/user">
                              <q-icon name="fa-solid fa-chevron-right" color="black" size=".6rem" />
                            </q-btn>
                          </div>
                          <q-list style="min-width: 100px">
                            <q-item clickable href="/user/orders">
                              <q-item-section>
                                <div class="flex items-center no-wrap">
                                  <q-icon name="fa-solid fa-hand-holding-droplet" left />
                                  Siparişlerim
                                </div>
                              </q-item-section>
                            </q-item>
                            <q-item clickable href="/user/favourites">
                              <q-item-section>
                                <div class="flex items-center no-wrap">
                                  <q-icon name="fa-regular fa-heart" left />
                                  Favorilerim
                                </div>
                              </q-item-section>
                            </q-item>
                            <q-separator />
                            <q-item clickable href="/user/contacts">
                              <q-item-section>
                                <div class="flex items-center no-wrap">
                                  <q-icon name="fa-regular fa-address-book" left />
                                  Adreslerim
                                </div>
                              </q-item-section>
                            </q-item>
                          </q-list>
                        </div>

                        <q-separator vertical inset class="q-mx-lg" />

                        <div class="column justify-center items-center">
                          <q-avatar size="72px" class="bg-grey-3">
                            <svg viewBox="0 0 24 24" width="50px" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                              <g id="SVGRepo_iconCarrier">
                                <circle cx="12" cy="6" r="4" stroke="#1C274C" stroke-width="1.5"></circle>
                                <ellipse opacity="0.5" cx="12" cy="17" rx="7" ry="4" stroke="#1C274C" stroke-width="1.5"></ellipse>
                              </g>
                            </svg>
                          </q-avatar>

                          <div class="text-subtitle1 q-mt-md q-mb-xs" v-if="me">{{ me.name }}</div>

                          <q-btn color="primary" label="Çıkış Yap" push size="sm" v-close-popup @click="logout" />
                        </div>
                      </div>
                    </q-menu>
                  </q-btn>
                </q-no-ssr>
              </div>
              <div v-else class="flex no-wrap items-center">
                <q-btn color="primary" no-caps href="/login-or-register" size=".75rem" dense class="q-px-sm" unelevated>
                  <q-icon name="fa-solid fa-circle-plus" size="1rem" left />
                  Kayıt Ol
                </q-btn>
                <span class="q-px-sm"> veya </span>
                <q-btn color="teal-4" text-color="black" no-caps href="/login-or-register" size=".75rem" dense class="q-px-sm" unelevated>
                  <q-icon name="fa-solid fa-arrow-right-to-bracket" size="1rem" left />
                  Giriş Yap
                </q-btn>
              </div>
            </div>

            <q-page-sticky expand position="bottom" style="z-index: 999; width: 100%" class="bg-white">
              <q-toolbar class="bg-accent text-white justify-end q-px-xs">
                <q-btn color="primary" no-caps href="/login-or-register" size=".85rem" dense class="q-px-sm" unelevated>
                  <q-icon name="login" size="1rem" left />
                  Giriş/Kayıt
                </q-btn>
                <div style="width: 1px; height: 15px; background-color: black; margin: 0 0.55rem"></div>
                <q-btn color="secondary" size=".85rem" unelevated class="header-mobile--basket_btn" dense href="/basket" no-caps>
                  <q-icon name="fa-solid fa-basket-shopping" size=".85rem" class="q-mr-sm" />
                  Sepetim
                  <q-badge rounded color="primary" :label="userBasketCount" class="q-ml-sm" style="position: relative; top: 1px" />
                </q-btn>
              </q-toolbar>
            </q-page-sticky>

            <!-- drawer content -->

            <!-- nav mobile start -->
            <q-drawer show-if-above v-model="mobileMenuOpen" side="left" bordered class="bg-primary">
              <q-toolbar class="text-white">
                <q-toolbar-title>
                  <div>
                    <q-icon name="apps" size="1.75rem" style="top: -2px" />
                    Ana Menü
                  </div>
                </q-toolbar-title>
                <q-space />
                <q-btn icon="close" flat round dense @click="toggleMenuDrawer" />
              </q-toolbar>
              <nav id="siteMobileNavigation" class="main-navigation">
                <ul id="primary-menu" class="menu">
                  <li
                    :class="{
                      'menu-item-has-children': !!Object.keys(nav.child).length,
                      'current-menu-item current-menu-ancestor': currentRoutePath === nav.link,
                    }"
                    :key="key"
                    v-for="(nav, key) in siteNav"
                    v-ripple
                  >
                    <a :href="`${siteAddress}${nav.link.startsWith('/') ? '' : '/'}${nav.link}`">
                      <span class="menu-item-icon" :style="{ backgroundImage: `url(/img/${nav.icon}.png)` }"></span>
                      {{ nav.name }}
                    </a>
                    <ul class="sub-menu" v-if="Object.keys(nav.child).length">
                      <li :class="currentRoutePath === child.link ? 'current-menu-item' : null" :key="childKey" v-for="(child, childKey) in nav.child">
                        <a :href="`${siteAddress}${child.link.startsWith('/') ? '' : '/'}${child.link}`"> {{ child.name }}</a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>
            </q-drawer>
            <!-- nav mobile end -->
          </div>
        </div>
      </div>
      <!-- nav start -->
      <div v-if="isDesktop" class="octf-col">
        <nav id="siteNavigation" class="main-navigation">
          <ul id="primary-menu" class="menu">
            <li
              :class="{
                'menu-item-has-children': !!Object.keys(nav.child).length,
                'current-menu-item current-menu-ancestor': currentRoutePath === nav.link,
              }"
              :key="key"
              v-for="(nav, key) in siteNav"
            >
              <a :href="`${siteAddress}${nav.link.startsWith('/') ? '' : '/'}${nav.link}`">
                <span class="menu-item-icon" :style="{ backgroundImage: `url(/img/${nav.icon}.png)` }"></span>
                {{ nav.name }}
              </a>
              <ul class="sub-menu" v-if="Object.keys(nav.child).length">
                <li :class="currentRoutePath === child.link ? 'current-menu-item' : null" :key="childKey" v-for="(child, childKey) in nav.child">
                  <a :href="`${siteAddress}${child.link.startsWith('/') ? '' : '/'}${child.link}`"> {{ child.name }}</a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        <!-- #site-navigation -->
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { PageStore } from 'stores/Page/Page.ts';
import { computed, defineComponent, inject, onMounted, type Ref, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { BasketStore } from 'stores/Basket/Basket.ts';
import { AuthStore } from 'stores/User/Auth.ts';
import SearchBar from 'components/Template/SearchBar.vue';
import { useQuasar } from 'quasar';

export default defineComponent({
  name: 'SiteHeader',
  components: { SearchBar },

  computed: {
    isHome() {
      return this.currentRoutePath === '/';
    },
    isNotFound() {
      return this.currentRoute === 404;
    },
    currentRoutePath() {
      return this.$router.currentRoute.value.path;
    },
    siteNav() {
      return this.header.mainNav;
    },
    siteSocialInfo() {
      return this.header.socialInfo || [];
    },
  },

  setup() {
    const $q = useQuasar();

    const pageStore = PageStore();
    const { head, header } = storeToRefs(pageStore);

    const isLogged = inject<Ref<boolean>>('isLogged');
    const me = inject<any>('me');
    const siteAddress = inject<string>('siteAddress');
    const currentRoute = inject<any>('currentRoute');

    const basketStore = BasketStore();
    basketStore.getUserBasketCount();
    const { userBasketCount } = storeToRefs(basketStore);

    const mobileMenuOpen = ref(false);

    const authStore = AuthStore();

    onMounted(() => {
      // Kullanıcı giriş yapmışsa local deki sepeti sunucuya senkronize et
      basketStore.syncLocalBasketToServer();
    });

    return {
      isLogged,
      me,
      siteAddress,
      currentRoute,
      head,
      header,
      userBasketCount,
      mobileMenuOpen,
      authStore,
      isDesktop: $q.platform.is.desktop,
      $q,
    };
  },
  methods: {
    toggleMenuDrawer() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },

    logout() {
      this.authStore.logout().then(() => {
        this.$q.notify({
          color: 'green',
          textColor: 'white',
          icon: 'check',
          message: 'Başarıyla çıkış yaptınız',
          position: 'bottom',
          timeout: Math.random() * 5000 + 3000,
        });
      });
    },
  },
});
</script>
<style scoped>
header .site-header--wrapper {
  /*background: linear-gradient(91deg, rgba(221, 207, 193, 0.33) 0%, rgba(204, 237, 255, 0.22) 48%, rgba(170, 155, 137, 0.56) 100%);*/
  background: #ffffff;
}

.site-header--top-concept {
  padding: 0.65rem 1rem;
  position: relative;
  background: #f0f0f0;
}

.octf-col.site-header--top-concept:before,
.octf-col.site-header--top-concept:after {
  background: #f0f0f0;
}

.octf-col.site-header--top-concept:before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: -100%;
}

.octf-col.site-header--top-concept:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: -100%;
}

.site-header--user-actions {
  display: flex;
  align-items: center;
  font-family: system-ui;
  font-size: 17px;
  font-weight: 500;
  margin-right: 5rem;
}

.site-header--social-platforms {
  display: flex;
  justify-content: center;
  align-items: center;
}

.site-header--social-platforms a.social {
  display: block;
  width: 20px;
  height: 20px;
  background-size: cover;
  background-repeat: no-repeat;
  margin-right: 0.9rem;
}

.site-header--social-platforms a.social:last-child {
  margin-right: 0;
}

.site-header--social-platforms a.social.social-facebook {
  width: 25px;
  height: 25px;
}
</style>

<style scoped>
.site-header--middle-concept {
  display: flex;
  justify-content: space-between;
  align-items: end;
}

.site-header--middle-concept .site-search-bar,
.site-header--middle-concept .site-user-area {
  padding-bottom: 2rem;
}

#siteNavigation {
  background: var(--q-primary);
  display: flex;
  justify-content: center;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;
}

#siteNavigation ul {
  display: flex;
  list-style-type: none;
  height: 100%;
  margin: 0;
  padding-left: 0;
  background-color: #eee;
  position: relative;
}

#siteNavigation ul:before,
#siteNavigation ul:after {
  content: '';
  position: absolute;
  top: 0;
  width: 53px;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
}

#siteNavigation ul:before {
  background-image: url('/img/menu-left-effect.svg');
  right: 100%;
  background-position: right;
  transform: translateX(1px);
}

#siteNavigation ul:after {
  background-image: url('/img/menu-right-effect.svg');
  left: 100%;
  background-position: left;
  transform: translateX(-1px);
}

#siteNavigation ul li {
  display: flex;
}

#siteNavigation ul li a {
  text-decoration: none;
  padding: 1rem 2rem;
  color: #111;
  font-size: 1.1rem;
  height: 100%;
  font-family: 'EB Garamond', serif;
  letter-spacing: 0.1rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  transition: 0.1s cubic-bezier(0.55, 0.06, 0.68, 0.19);
}

#siteNavigation ul li a:hover {
  background-color: #ddd;
}

#siteNavigation .menu-item-icon {
  display: block;
  width: 35px;
  height: 35px;
  background-size: cover;
  background-repeat: no-repeat;
  margin-right: 1rem;
}

#siteNavigation ul li:first-child a .menu-item-icon {
  width: 35px;
  height: 35px;
}

#site-header .h-header--slogan {
  font-family: 'EB Garamond', serif;
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.02rem;
}
</style>

<style scoped lang="sass">
.header-mobile

  &--wrapper
    display: flex
    justify-content: center
    flex-wrap: nowrap
    padding: 1.5rem 0 .25rem
    background-color: $grey-12
    position: relative

  &--logo
    padding: 0 1rem

    img
      max-width: 100%
      height: auto

  &--burger-menu
    position: absolute
    top: 15px
    right: 15px

    ::v-global(.header-mobile--burger-menu .q-btn)
      border-radius: 5px
      padding: .25rem .75rem

  &--sub
    padding: 0 1rem

  &--user
    display: flex
    justify-content: space-between
    align-items: center
    padding: 1rem
    background-color: $grey-12

    &_text
      display: flex
      align-items: center

      p
        margin: 0
        font-weight: 600
        font-size: 1.1rem

  &--basket_btn
    margin-right: .5rem
    padding: 0.35rem .75rem .35rem 1rem
    border-radius: 5px

  &--profile_btn
    background-color: $grey-4
    border-radius: 5px
    padding: 0.35rem .75rem .35rem 1.5rem

    &-down
      display: inline-block
      margin-left: 0.5rem
      font-size: 0.9rem
      color: $grey-8
      border-left: 1px solid $grey-5

::v-global(.header-mobile--sub .site-search-bar)
  padding-bottom: 1.25rem !important

::v-global(.header-mobile--sub .site-search-bar .h-search-form-inner)
  max-width: 100%
  min-width: auto !important
  flex-grow: 1

#siteMobileNavigation
  display: flex
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px

  ul
    display: flex
    flex-direction: column
    list-style-type: none
    width: 100%
    height: 100%
    margin: 0
    padding-left: 0
    background-color: #fff
    position: relative

  ul li
    display: flex
    border-bottom: 1px solid $grey-4


  ul li a
    text-decoration: none
    padding: 1rem 1rem
    color: #111
    font-size: 1.1rem
    width: 100%
    height: 100%
    font-family: 'EB Garamond', serif
    letter-spacing: 0.1rem
    font-weight: 600
    display: flex
    align-items: center
    transition: 0.1s cubic-bezier(0.55, 0.06, 0.68, 0.19)


  ul li a:hover
    background-color: #ddd


  .menu-item-icon
    display: block
    width: 35px
    height: 35px
    background-size: cover
    background-repeat: no-repeat
    margin-right: 1rem

  ul li:first-child a .menu-item-icon
    width: 35px
    height: 35px


#site-header .h-header--slogan
  font-family: 'EB Garamond', serif
  font-size: 1rem
  font-weight: 500
  letter-spacing: 0.02rem
</style>
